// src/utils/permissionsCache.js

const PERMISSIONS_CACHE_KEY = 'kd_admin_permissions';
const PERMISSIONS_TIMESTAMP_KEY = 'kd_admin_permissions_timestamp';
const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

export const permissionsCache = {
    // Get cached permissions if they exist and are not expired
    get: () => {
        try {
            const cached = localStorage.getItem(PERMISSIONS_CACHE_KEY);
            const timestamp = localStorage.getItem(PERMISSIONS_TIMESTAMP_KEY);

            if (!cached || !timestamp) {
                return null;
            }

            const cacheAge = Date.now() - parseInt(timestamp);
            if (cacheAge > CACHE_DURATION) {
                console.log('Permissions cache expired, clearing...');
                permissionsCache.clear();
                return null;
            }

            return JSON.parse(cached);
        } catch (error) {
            console.warn('Failed to get cached permissions:', error);
            permissionsCache.clear();
            return null;
        }
    },

    // Set permissions in cache with timestamp
    set: (permissions) => {
        try {
            localStorage.setItem(PERMISSIONS_CACHE_KEY, JSON.stringify(permissions));
            localStorage.setItem(PERMISSIONS_TIMESTAMP_KEY, Date.now().toString());
            console.log('Permissions cached successfully');
        } catch (error) {
            console.warn('Failed to cache permissions:', error);
        }
    },

    // Clear permissions cache
    clear: () => {
        localStorage.removeItem(PERMISSIONS_CACHE_KEY);
        localStorage.removeItem(PERMISSIONS_TIMESTAMP_KEY);
        console.log('Permissions cache cleared');
    },

    // Check if cache exists and is valid
    isValid: () => {
        const timestamp = localStorage.getItem(PERMISSIONS_TIMESTAMP_KEY);
        if (!timestamp) return false;

        const cacheAge = Date.now() - parseInt(timestamp);
        return cacheAge <= CACHE_DURATION;
    }
};